import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Model/tree.persist.ts";
import "regenerator-runtime/runtime.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable no-await-in-loop */
import { createEffect, createEvent, restore } from 'effector';
import { isNotEmpty } from '@gmini/utils';
var setPreloadPending = createEvent({
  name: "setPreloadPending",
  sid: "sf3s6e"
});
export var resetPreloadPending = createEvent({
  name: "resetPreloadPending",
  sid: "p5q9g4"
});
export var preloadPending$ = restore(setPreloadPending, true, {
  name: "preloadPending$",
  sid: "-563egg"
}).reset(resetPreloadPending); // TODO Выпилить

export var loadNodes = createEffect({
  handler: function () {
    var _handler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var nodes, fetchChildren, opened, items, _iterator, _step, nRef;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nodes = _ref.nodes, fetchChildren = _ref.fetchChildren;
              opened = nodes;
              items = Object.values(opened).filter(isNotEmpty).filter(function (nRef) {
                return nRef.type === 'Category';
              });
              _iterator = _createForOfIteratorHelper(items);
              _context.prev = 4;

              _iterator.s();

            case 6:
              if ((_step = _iterator.n()).done) {
                _context.next = 12;
                break;
              }

              nRef = _step.value;
              _context.next = 10;
              return fetchChildren({
                id: nRef.id
              })["catch"](function () {
                Promise.resolve();
              });

            case 10:
              _context.next = 6;
              break;

            case 12:
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);

              _iterator.e(_context.t0);

            case 17:
              _context.prev = 17;

              _iterator.f();

              return _context.finish(17);

            case 20:
              setPreloadPending(false);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14, 17, 20]]);
    }));

    function handler(_x) {
      return _handler.apply(this, arguments);
    }

    return handler;
  }()
}, {
  name: "loadNodes",
  sid: "jaj9ap"
});
export function getFromPersist(key) {
  try {
    var raw = localStorage.getItem(key);
    return JSON.parse(raw || '[]');
  } catch (err) {
    return [];
  }
}
export function saveToPersist(_ref2) {
  var key = _ref2.key,
      nodes = _ref2.nodes;
  localStorage.setItem(key, JSON.stringify(nodes));
}